/**
 * What went wrong, then what to do now — as two sentences, not one run-on.
 *
 * Nearly every failure in this interface is reported the same way: the
 * server's own sentence, then a sentence the product adds saying what is safe
 * and what to try. The join between them was a bare space, and a server
 * sentence does not end in a full stop — so a writer was shown
 *
 *     "nav.yaml" does not exist The page is still there. Pick it again…
 *
 * which reads as one broken sentence and hides the part that was written for
 * them. Punctuating at the seam is a one-line rule, and one place is where a
 * one-line rule belongs: thirty call sites each deciding it is thirty chances
 * to get it wrong, and it was wrong at all of them.
 *
 * A blank message is dropped rather than punctuated: "." followed by advice is
 * worse than the advice alone.
 */
export function because(problem: unknown, whatNow: string): string {
  const said = (problem instanceof Error ? problem.message : String(problem)).trim()
  if (said === '') return whatNow
  // Ellipsis and colon included: a server that trails off, or introduces a
  // list, has already punctuated its own end.
  return `${said}${/[.!?:…]$/.test(said) ? '' : '.'} ${whatNow}`
}
